export default __webpack_public_path__ + "static/media/menu-profile.81b30496.svg";